var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemRecordsIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "System_records_icon_1",
    "data-name": "System records icon 1",
    d: "M11.7,18h-9A2.7,2.7,0,0,1,0,15.3V2.7A2.7,2.7,0,0,1,2.7,0H8.145a.79.79,0,0,1,.3.1l.04,0,.041,0A.959.959,0,0,1,8.775.27l5.4,5.4a.959.959,0,0,1,.171.252V6a1.194,1.194,0,0,1,.054.243V15.3A2.7,2.7,0,0,1,11.7,18ZM4.5,12.6a.9.9,0,1,0,0,1.8H9.9a.9.9,0,1,0,0-1.8ZM4.5,9a.9.9,0,1,0,0,1.8H9.9A.9.9,0,1,0,9.9,9Zm0-3.6a.9.9,0,1,0,0,1.8h.9a.9.9,0,1,0,0-1.8ZM9,3.069V4.5a.9.9,0,0,0,.9.9h1.431Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemRecordsIcon1);
export default __webpack_public_path__ + "static/media/System_records_icon_1.729b788acef09f66824f63a94deaa005.svg";
export { ForwardRef as ReactComponent };